module.exports = __webpack_public_path__ + "static/media/accMenus.a615942a.png";